import { render, staticRenderFns } from "./topUserModal.vue?vue&type=template&id=70b14fe9&"
import script from "./topUserModal.vue?vue&type=script&lang=js&"
export * from "./topUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports